import { render, staticRenderFns } from "./PropertyType.vue?vue&type=template&id=089fd330"
import script from "./PropertyType.vue?vue&type=script&lang=js"
export * from "./PropertyType.vue?vue&type=script&lang=js"
import style0 from "./PropertyType.vue?vue&type=style&index=0&id=089fd330&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports